import React, {useState, useEffect,Suspense, lazy} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Crypto_prices from './pages/Crypto_prices';
import { registerToastSetter } from './API/AxiosInstance';
import { authEvents$ } from './API/AxiosInstance';
import { setAuth0Client } from './API/auth0Client';
import { useAuth0 } from '@auth0/auth0-react';
import CommonLoader from './components/CommonLoader';
import Dashboard from "./pages/Dashboard";
import Overview from "./pages/Overview";
import News from "./pages/News";
import Portfolio from "./pages/Portfolio";
import Sumsubkyc from "./pages/Sumsubkyc";
import Settings from "./pages/Settings/Settings";
import Transactions from "./pages/Transactions/Transactions";
import Messages from "./pages/Messages";
import Products from "./pages/Products";
import ProductDetails from "./pages/Products/ProductDetails";
import Questionaire from "./pages/Questionaire/Questionaire";
import SuccessSubscribed from "./pages/Products/SuccessSubscribed";
import EditProfile from "./components/UserAccount/EditProfile";
import DocusignReponse from "./pages/Settings/DocuSignResponse";
import Signup from "./pages/Signup";
import ToastAlert from "./utils/Toaster";
import ErrorModal from "./utils/Error401Modal";
import MainDashboardEntry from "./pages/MainDashboardEntry ";
import NotificationList from "./pages/Notifications/NotificationList";
import NotificationDetails from "./pages/Notifications/NotificationDetails";



function App() {
  const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const auth0 = useAuth0();
  setAuth0Client(auth0);

  console.log = function() {}
  console.warn = function() {}
  console.error = function() {}
  // Register Firebase Service Worker
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered:", registration);
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

useEffect(() => {
  registerToastSetter(setToastStatus);
}, []);

useEffect(() => {
    const unsubscribe = authEvents$.subscribe(async (event) => {
      if (event.type === '401') {
          console.log("App.js caught 401 via observable");
          setErrorModalOpen(true)
      }
    });

    return () => unsubscribe(); 
  }, []);


  const handleRetry = () => {
    window.location.reload()
  }


const withSuspense = (Component) => (
  <Suspense fallback={<CommonLoader />}>
    <Component />
  </Suspense>
);


  return (
    <>
    {/* <ToastContainer toasts={toasts} onRemove={(id) => setToasts((p) => p.filter((t) => t.id !== id))} /> */}
    <ErrorModal  open={errorModalOpen} onRetry={handleRetry} />
    <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
      <BrowserRouter>
        <Routes>
          <Route path="/Questionnaire" element={<Questionaire />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/" element={<MainDashboardEntry/>}>
          <Route index element={<Overview />} />
          <Route path="Cryptoprices" element={<Crypto_prices />} />
          <Route path="News" element={<News />} />
          <Route path="Portfolio" element={<Portfolio />} />
          <Route path="Sumsubkyc" element={<Sumsubkyc />} />
          <Route path="Settings" element={<Settings />} />
          <Route path="Transactions" element={<Transactions />} />
          <Route path="Messages" element={<Messages />} />
          <Route path="Products" element={<Products />} />
          <Route path="Products/ProductDetails/:id" element={<ProductDetails />} />
          <Route path="SuccessSubscribed" element={<SuccessSubscribed />} />
          <Route path="editProfile" element={<EditProfile />} />
          <Route path="docusignResponse" element={<DocusignReponse />} />
          <Route path="notification" element={<NotificationList />} />
          <Route path="notificationDetail/:id" element={<NotificationDetails />} />
        </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

// export default Sentry.withProfiler(App)
export default App